module.exports = __webpack_public_path__ + "media/images/logo-763c7665.svg";